/**
 * Created by Ning Jiang on 3/6/2019.
 */
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";
import {BitmapTextStyleData} from "./PPWaysWonGFXText";

export class PixiesVsPiratesInitialWPView extends BaseView {

    private readonly _winNumberStyle:BitmapTextStyleData = {
        fontName : "NumbersPopFont",
        fontSize : 12,
        tint : 0xffffff
    };
    private readonly _winNumberTotalDuration:number = 2;
    private readonly _winNumberFadeOutDuration:number = 1.5;
    private readonly _winNumberOffsetY:number = -100;
    private readonly _winNumberInterval:number = 0.2;
    private readonly _maxWinNumberWidth:number = GameConfig.instance.SYMBOL_WIDTH;

    private _winSwirls:TimelineSprite[];
    private _winSwirlsPool:TimelineSprite[];
    private _layer:ScalableLayer;

    constructor() {
        super();

        this._layer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
        this._winSwirls = [];
        this._winSwirlsPool = [];
    }

    public playWinOnSymbol(symbol:StateReelSymbol, position:[number, number]):Timeline {
        const swirl:TimelineSprite = this.getSwirl();
        const scale:number = MathHelper.roundToDecimals(symbol.symHeight / GameConfig.instance.SYMBOL_HEIGHT, 4);
        swirl.position.set(position[0], position[1]);
        swirl.scale.set(scale);
        swirl.hide();
        this._winSwirls.push(swirl);
        this._layer.addChild(swirl);

        return swirl.getAnimationAutoShowHide(true, true, [0], undefined, () => {
            ArrayHelper.removeFirstMatchElement(this._winSwirls, swirl);
            this.removeSwirl(swirl);
        });
    }

    private getSwirl():TimelineSprite {
        if(this._winSwirlsPool.length > 0) {
            return this._winSwirlsPool.pop()!;
        }

        const swirl:TimelineSprite = new TimelineSprite(GameResources.getTextures("winSwirl"));
        swirl.anchor.set(0.5, 0.5);
        swirl.blendMode = PIXI.BLEND_MODES.ADD;
        return swirl;
    }

    public playWinNumbers(betWayWinData:IBetWayWinData, startPosition:[number, number]):TimelineLite {
        let text:string = Currency.formatValue(MathHelper.roundToDecimals(betWayWinData.amount / betWayWinData.numberOfCombinations, 2));
        if(betWayWinData.multiplier > 1) {
            text += ` X ${betWayWinData.multiplier}`;
        }

        const timeline:TimelineLite = new TimelineLite({paused : true});
        for(let i:number = 0; i < betWayWinData.numberOfCombinations; i++) {
            timeline.add(() => this.playWinNumberAnimation(text, startPosition), this._winNumberInterval * i);
        }

        return timeline;
    }

    // do not abort this ever, like wixx.
    private playWinNumberAnimation(text:string, startPosition:[number, number]):void {
        // Logger.logDev(`win number position = [${startPosition[0]}, ${startPosition[1]}]`);
        const winNumber:PIXI.BitmapText = new PIXI.BitmapText(text, this._winNumberStyle);
        (<PIXI.Point>winNumber.anchor).set(0.5, 0.5);
        winNumber.position.set(startPosition[0], startPosition[1]);
        this._layer.addChild(winNumber);
        winNumber.updateTransform();
        if(winNumber.width > this._maxWinNumberWidth) {
            const scale:number = MathHelper.roundToDecimals(this._maxWinNumberWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
        }
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(TweenLite.to(winNumber, this._winNumberTotalDuration, {y : startPosition[1] + this._winNumberOffsetY}));
        timeline.add(TweenLite.to(winNumber, this._winNumberFadeOutDuration, {alpha : 0}), `-=${this._winNumberFadeOutDuration}`);
        timeline.add(() => {
            this._layer.removeChild(winNumber);
            winNumber.destroy();
        });
    }

    public abort():void {
        while(this._winSwirls.length > 0) {
            const swirl:TimelineSprite = this._winSwirls.pop()!;
            this.removeSwirl(swirl);
        }
    }

    private removeSwirl(swirl:TimelineSprite):void {
        this._layer.removeChild(swirl);
        this._winSwirlsPool.push(swirl);
    }
}